import Vue from 'vue';
import { store } from '../../store/store';

Vue.mixin({
  methods: {
    handleError(error, errorBag) {
      const { response } = error;
      const messages = response && response.data && response.data.message
        ? response.data.message
        : '';

      const errors = response && response.data && response.data.errors
        ? response.data.errors
        : null;

        if (response) {
        if (errors && typeof (errors) === 'object' && errors.constructor !== Array && errorBag && response.status === 422) {
          errorBag.setErrors(errors);
          store.dispatch('alert/showToast', { type: 'error', message: messages });
        } else {
          let messagesFields = messages;
          if (errors && typeof errors === 'object') {
            messagesFields = '';
            Object.keys(errors).forEach((field) => {
              messagesFields += errors[field];
            });
          }
          store.dispatch('alert/showToast', { type: 'error', message: messagesFields });
        }
      } else {
        store.dispatch('alert/showToast', { type: 'error', message: this.$t('NETWORK_ERROR') });
      }
    },
    /**
     * This method return pagination object for data returned by server and for pure array
     * @param data
     * @param options
     * @returns {{totalItems: *, page: (*|number), rowsPerPage: (*|number)}}
     */

     getPagination(data, options = {}) {
      const { oldPagination, forcePage } = options;
      // eslint-disable-next-line
      const { current_page, last_page, total, per_page } = data;
      let pagination = {
        // eslint-disable-next-line
        page: forcePage || current_page || 1,
        // eslint-disable-next-line
        itemsPerPage: parseInt(per_page) || 20,
        // eslint-disable-next-line
        totalItems: parseInt(total) || data.length,
      };
      // eslint-disable-next-line
      pagination.totalPages = last_page
      || Math.ceil(pagination.totalItems / pagination.itemsPerPage);
      if (typeof (oldPagination) === 'object') {
        pagination = { ...oldPagination, ...pagination };
      }
      return pagination;
    },
  },
});
